import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTargetIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 1000 1000",
	enableBackground: "new 0 0 1000 1000",
	xmlSpace: "preserve",
	...props,
	children: [/* @__PURE__ */ _jsx("metadata", { children: " Svg Vector Icons : http://www.onlinewebfonts.com/icon " }), /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("g", {
			id: "Rectangle_45_copy_7",
			children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", { d: "M901.8,467.3c-11-199-170.1-358.2-369.2-369.1V10h-43.6v88.2c-199,11-358.2,170.1-369.2,369.1H10v43.6h110c11,199,170.1,358.2,369.2,369.1v110h43.6V880c199-11,358.2-170.1,369.2-369.1H990v-43.6L901.8,467.3L901.8,467.3z M858.3,510.9c-10.8,175-150.6,314.7-325.6,325.6V663.3h-43.6v173.1c-175-10.9-314.8-150.6-325.6-325.6h173.2v-43.6H163.5c10.8-175,150.6-314.7,325.6-325.6v173.1h43.6V141.8c175,10.9,314.8,150.6,325.6,325.6H685.1v43.6H858.3L858.3,510.9z" }) })
		}) }),
		/* @__PURE__ */ _jsx("g", {}),
		/* @__PURE__ */ _jsx("g", {}),
		/* @__PURE__ */ _jsx("g", {}),
		/* @__PURE__ */ _jsx("g", {}),
		/* @__PURE__ */ _jsx("g", {}),
		/* @__PURE__ */ _jsx("g", {}),
		/* @__PURE__ */ _jsx("g", {}),
		/* @__PURE__ */ _jsx("g", {}),
		/* @__PURE__ */ _jsx("g", {}),
		/* @__PURE__ */ _jsx("g", {}),
		/* @__PURE__ */ _jsx("g", {}),
		/* @__PURE__ */ _jsx("g", {}),
		/* @__PURE__ */ _jsx("g", {}),
		/* @__PURE__ */ _jsx("g", {}),
		/* @__PURE__ */ _jsx("g", {})
	] })]
});
export default SvgTargetIcon;
